import { createContext, type FunctionComponent, type ReactNode, useContext } from "react";

type ContextValue = {
  isCftPage: boolean;
};

type Props = {
  children: ReactNode;
};

const CftContext = createContext<ContextValue>({
  isCftPage: false,
});

export const CftContextProvider: FunctionComponent<Props> = ({ children }) => (
  <CftContext.Provider
    value={{
      isCftPage: true,
    }}
  >
    {children}
  </CftContext.Provider>
);

export const useCftContext = () => useContext(CftContext);
